import type { LocalImageService } from 'astro'
import sharpService from 'astro/assets/services/sharp'
import { baseDevService } from './shared.js'

const service: LocalImageService = {
    ...baseDevService,
    getHTMLAttributes(options, serviceOptions) {
        const { inputtedWidth, ...props } = options

        // If `validateOptions` returned a different width than the one of the image, use it for attributes
        if (inputtedWidth) {
            props.width = inputtedWidth
        }

        return sharpService.getHTMLAttributes
            ? sharpService.getHTMLAttributes(props, serviceOptions)
            : {}
    },
    transform(inputBuffer, transform, serviceOptions) {
        transform.format = transform.src.endsWith('svg') ? 'svg' : 'webp'

        return sharpService.transform(inputBuffer, transform, serviceOptions)
    },
}

export default service
